export default "__VITE_ASSET__4d6e2e1d__"